import moment from 'moment-timezone';

import SessionBroadcast from './SessionBroadcast';

class SessionBroadcastManager {
    constructor(broadcastsRaw) {
        const timezone = moment.tz.guess();
        this.broadcasts = broadcastsRaw.map((broadcast) => new SessionBroadcast(broadcast, timezone));

        this._liveBroadcastChangeCallbacks = [];

        let liveBroadcast = this.getLiveBroadcast();
        setInterval(() => {
            const newLiveBroadcast = this.getLiveBroadcast();

            if (newLiveBroadcast.name !== liveBroadcast.name) {
                this._liveBroadcastChangeCallbacks.map((cb) => cb(newLiveBroadcast));
            }
            liveBroadcast = newLiveBroadcast;
        }, 1000*5);
    }

    onLiveBroadcastChange(cb) {
        if (typeof cb !== 'function') console.error("listener must be a function");

        this._liveBroadcastChangeCallbacks.push(cb);
    }

    /**
     * Returns SessionBroadcast of session that is currently live.
     * Returns false if no broadcast is live.
     *
     * @return {SessionBroadcast|boolean}
     */
    getLiveBroadcast() {
        const now = moment();

        let liveBroadcast;
        for (let i = this.broadcasts.length-1; i >= 0; i--) {
            if (this.broadcasts[i].startMoment <= now) {
                liveBroadcast = this.broadcasts[i];
                break;
            }
        }
        return liveBroadcast || false;
    }
}

export default SessionBroadcastManager;



// WEBPACK FOOTER //
// ./src/models/SessionBroadcastManager.js